/**
 * Use Case: Obter Produtos
 * Responsabilidade: Orquestra a busca de produtos
 * Princípios: Single Responsibility, Dependency Inversion
 */

import { IProductRepository } from '../../../domain/repositories/IProductRepository';
import { Product } from '../../../domain/entities/Product';

export interface GetProductsDTO {
    organizationId: string;
}

export class GetProductsUseCase {
    constructor(private readonly productRepository: IProductRepository) { }

    async execute(dto: GetProductsDTO): Promise<Product[]> {
        return await this.productRepository.findAll(dto.organizationId);
    }
}
